var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 116,
    viewBox: "0 0 130 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 18.0935L32.5 2.99805H65H121.333C126.12 2.99805 130 6.86002 130 11.624V107.372C130 112.136 126.12 115.998 121.333 115.998H8.66667C3.8802 115.998 0 112.136 0 107.372V59.498V31.248L15.1667 18.0935Z",
    fill: "url(#paint0_linear_13490_128392)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.170784 30.8198L22.1115 33.8589C27.276 34.5742 31.894 30.5898 31.9429 25.3762L32.1594 2.28941C32.1594 2.28941 26.849 6.97532 16.1651 16.5546C5.4812 26.1339 0.170784 30.8198 0.170784 30.8198Z",
    fill: "url(#paint1_linear_13490_128392)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9866 49.0539C34.3839 50.4163 34.3295 52.5746 32.8651 53.8745L24.4852 61.3132L32.9284 69.1791C34.3586 70.5116 34.357 72.6705 32.9248 74.0011C31.4925 75.3317 29.172 75.3302 27.7418 73.9977L14 61.1954L27.8051 48.9408C29.2695 47.6409 31.5893 47.6915 32.9866 49.0539Z",
    fill: "#8EC2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9627 49.0539C96.6353 50.4163 96.687 52.5746 98.0782 53.8745L106.039 61.3132L98.0181 69.1791C96.6593 70.5116 96.6609 72.6705 98.0215 74.0011C99.3821 75.3317 101.587 75.3302 102.945 73.9977L116 61.1954L102.885 48.9408C101.494 47.6409 99.2901 47.6915 97.9627 49.0539Z",
    fill: "#8EC2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5753 48.5905C73.0682 49.6461 73.4489 51.7504 72.4257 53.2905L58.9805 73.5282C57.9573 75.0684 55.9176 75.4612 54.4247 74.4056C52.9318 73.35 52.5511 71.2457 53.5743 69.7056L67.0195 49.4678C68.0427 47.9277 70.0824 47.5349 71.5753 48.5905Z",
    fill: "url(#paint2_linear_13490_128392)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 69.498C45 70.8788 43.8807 71.998 42.5 71.998C41.1193 71.998 40 70.8788 40 69.498C40 68.1173 41.1193 66.998 42.5 66.998C43.8807 66.998 45 68.1173 45 69.498Z",
    fill: "#F96652"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52 69.498C52 70.8788 51.1046 71.998 50 71.998C48.8954 71.998 48 70.8788 48 69.498C48 68.1173 48.8954 66.998 50 66.998C51.1046 66.998 52 68.1173 52 69.498Z",
    fill: "#F96652"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69.498C73 70.8788 71.8807 71.998 70.5 71.998C69.1193 71.998 68 70.8788 68 69.498C68 68.1173 69.1193 66.998 70.5 66.998C71.8807 66.998 73 68.1173 73 69.498Z",
    fill: "#F96652"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81 69.498C81 70.8788 79.8807 71.998 78.5 71.998C77.1193 71.998 76 70.8788 76 69.498C76 68.1173 77.1193 66.998 78.5 66.998C79.8807 66.998 81 68.1173 81 69.498Z",
    fill: "#F96652"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89 69.498C89 70.8788 87.8807 71.998 86.5 71.998C85.1193 71.998 84 70.8788 84 69.498C84 68.1173 85.1193 66.998 86.5 66.998C87.8807 66.998 89 68.1173 89 69.498Z",
    fill: "#F96652"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13490_128392",
    x1: 4.0625,
    y1: 9.03621,
    x2: 145.143,
    y2: 96.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997522,
    stopColor: "#D8FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13490_128392",
    x1: 15.9362,
    y1: 33.9769,
    x2: 18.4691,
    y2: 1.2305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5F8C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7FFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13490_128392",
    x1: 63,
    y1: 51.3792,
    x2: 63,
    y2: 71.6169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36C5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DDCFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.559e215a86eb2ce2c1d0e1ac2150e276.svg";
export { ForwardRef as ReactComponent };